import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function ForgotDialog({ open, onClose }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      toast.success("If that email has an account, a reset link is on its way");
      onClose();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-panel border-line text-hi max-w-sm" data-testid="forgot-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-black uppercase tracking-wide">Reset password</DialogTitle>
          <DialogDescription className="text-mid text-sm">
            We'll email a one-hour, single-use reset link to the account address.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={send} className="mt-2 space-y-4">
          <Input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@garage.co.uk"
            data-testid="forgot-email-input"
            className="bg-ink border-line"
          />
          <button
            type="submit"
            data-testid="forgot-send-button"
            disabled={busy}
            className="w-full rounded-full bg-ember py-3 font-display text-lg font-bold uppercase tracking-wider text-ink hover:bg-ember/90 disabled:opacity-40 transition"
          >
            {busy ? "Sending…" : "Email reset link"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
